import { SupportDocument } from '../../schemas/SupportDocument'
import apiClient from '../apiClient'

class SupportDocumentService {
  /** Persists a support document for the authenticated entity. */
  async save(data: SupportDocument) {
    try {
      const responseApi = await apiClient.post('/api/v2/support-document', data)
      return responseApi.data
    } catch (error) {
      throw error
    }
  }

  /** Returns a paginated list of support documents. */
  async list(page: number) {
    try {
      const responseApi = await apiClient.get('/api/v2/support-document', {
        params: {
          page,
        }
      })
      return responseApi.data.data.data
    } catch (error) {
      throw error
    }
  }

  /** Returns printable HTML for a support document. */
  async getSupportDocumentHTML(cude: string): Promise<string> {
    try {
      const responseApi = await apiClient.get(`/api/v2/support-document/${cude}/html`, {
        headers: {
          'Content-Type': 'text/html; charset=utf-8'
        }
      })

      return responseApi.data
    } catch (error) {
      throw error
    }
  }

  /** Presents a support-document credit note for the given CUDE. */
  async presentCreditNoteSupportDocument(cude: string): Promise<any> {
    try {
      const responseApi = await apiClient.post(`/api/v2/support-document/${cude}/present-credit`, null)
      return responseApi.data
    } catch (error) {
      throw error
    }
  }

  /** Returns paginated support-document credit notes from Plemsi. */
  async getCreditNoteSupportDocumentsFromPlemsi(page: number) {
    try {
      const responseApi = await apiClient.get('/api/v2/support-document/credit/plemsi', {
        params: {
          page,
        }
      })
      return responseApi.data.data
    } catch (error) {
      throw error
    }
  }

  /** Returns HTML for printing a support-document credit note. */
  async getCreditNoteSupportDocumentHTML(cude: string): Promise<string> {
    try {
      const responseApi = await apiClient.get(`/api/v2/support-document/credit/${cude}/html`, {
        headers: {
          'Content-Type': 'text/html; charset=utf-8'
        }
      })

      return responseApi.data
    } catch (error) {
      throw error
    }
  }

}

export default SupportDocumentService
